var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Exit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    transform: "translate(-588.000000, -3617.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Exit",
    transform: "translate(588.000000, 3617.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F7931D",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    transform: "translate(16.609367, 17.103138) rotate(-45.000000) translate(-16.609367, -17.103138) ",
    x: -2.13336708,
    y: 12.6031384,
    width: 37.4854675,
    height: 9,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    transform: "translate(16.609367, 17.103138) rotate(-135.000000) translate(-16.609367, -17.103138) ",
    x: -2.13336708,
    y: 12.6031384,
    width: 37.4854675,
    height: 9,
    rx: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveGame);
export default __webpack_public_path__ + "static/media/leave-game.1dddc6c80cbf1db889f39a653977dd77.svg";
export { ForwardRef as ReactComponent };